import React, { CSSProperties } from 'react';
import List from '@material-ui/core/List';
import { Uds } from '../../types';

export type MenuListProps = Uds<{
  children?: any;
  style?: CSSProperties;
  className?: string;
  ariaLabel?: string;
  /* ! please use ariaLabel */
  'aria-label'?: undefined;
}>;

const MenuList: React.FC<React.PropsWithChildren<MenuListProps>> = ({
  children,
  style,
  className,
  dataTest,
  ariaLabel
}) => (
  <List
    className={className}
    style={style}
    component="nav"
    aria-label={ariaLabel ?? 'oc-menu-list'}
    data-test={dataTest ?? 'menu-list'}
  >
    {children}
  </List>
);

export default MenuList;
